module.exports = __webpack_public_path__ + "static/media/CLIENTLOGOS.3de5b7ee.png";